import type { ReactNode } from "react";

interface Props {
  icon: ReactNode;
  title: string;
  count: number;
  children: ReactNode;
}

export default function AdAccountGroup({ icon, title, count, children }: Props) {
  return (
    <section className="space-y-3">
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <div className="flex items-center gap-2">
          {icon}
          <span>{title}</span>
        </div>
        <span>{count}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {children}
      </div>
    </section>
  );
}
